import Image from 'next/image';
import { useRouter } from 'next/router';
import { Box, Typography } from '@mui/material';

const HeaderIconGroup = ({ isMobile, auth, onSearch, onBasket, onProfile }) => {
    const account = auth?.account?.accountInfo;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: isMobile ? 2 : 3 }}>
            {/* Хайлт */}
            <Image
                width={16}
                height={16}
                src={require('public/search.svg')}
                alt="Хайлт"
                className="object-contain cursor-pointer"
                onClick={onSearch}
            />

            {/* Сагс */}
            <Box sx={{ position: 'relative', cursor: 'pointer' }} onClick={onBasket}>
                <Image
                    width={18}
                    height={18}
                    src={require('public/basket.svg')}
                    alt="Сагс"
                    className="object-contain"
                />
                {account?.basketCount > 0 && (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: -6,
                            right: -7,
                            width: 16,
                            height: 16,
                            borderRadius: '50%',
                            background: '#ef4444',
                            color: '#fff',
                            fontSize: 9,
                            fontWeight: 700,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        {account.basketCount}
                    </Box>
                )}
            </Box>

            {/* Профайл */}
            <Box
                sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' }}
                onClick={onProfile}
            >
                {auth?.accountLoggedIn ? (
                    <Box
                        sx={{
                            width: isMobile ? 26 : 28,
                            height: isMobile ? 26 : 28,
                            borderRadius: '50%',
                            overflow: 'hidden',
                            flexShrink: 0,
                            border: '1.5px solid hsl(var(--primary) / 0.3)',
                            background: '#f3f4f6',
                        }}
                    >
                        <img
                            src={account?.photo || '/pages/profile/user_white_bg.svg'}
                            alt="Профайл"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                display: 'block',
                            }}
                        />
                    </Box>
                ) : (
                    <Image
                        width={18}
                        height={18}
                        src={require('public/user.svg')}
                        alt="Профайл"
                        className="object-contain"
                    />
                )}
                {!isMobile && auth?.accountLoggedIn && account?.first_name && (
                    <Typography
                        variant="body13"
                        sx={{ color: '#374151', fontWeight: 500, transform: 'translateY(1px)' }}
                    >
                        {account.first_name}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default HeaderIconGroup;
